
import API from '@/api'
import router from '@/router'

const actions = {
  getProfile({ commit, rootGetters }) {
    API.profile.get()
      .then(({ data: { data: { agency, ...user } } }) => {
        commit('setUserProfile', user)
        commit('setAgencyProfile', agency)
        commit('myAgency/setUserForm', user, { root: true })
        commit('account/setAccess', user.role, { root: true })

        if (Object.prototype.hasOwnProperty.call(router.currentRoute.meta, 'access')) {
          if (!rootGetters[`account/${router.currentRoute.meta.access}`]) {
            router.push({ name: 'AccessDenied' })
          }
        }
      })
      .catch(() => {
        commit('account/logout', null, { root: true })
        commit('account/setAccess', { name: 'GUEST' }, { root: true })
      })
  },
  updateUserProfile({ dispatch, commit }, payload) {
    API.profile.update(payload)
      .then(({ data: { data } }) => {
        commit('setUserProfile', payload)
        commit('myAgency/changeShowUserForm', false, { root: true })
        dispatch('getProfile')
      })
      .catch(({ data: { errors } }) => {
        commit('setUserFormErrors', errors)
      })
  },
  updateUserAvatar({ dispatch, commit }, payload) {
    API.profile.updateAvatar(payload)
      .then(({ data: { data } }) => {
        commit('myAgency/changeShowUserForm', false, { root: true })
        dispatch('getProfile')
      })
      .catch(({ data: { errors } }) => {
        commit('myAgency/changeShowUserForm', false, { root: true })
      })
  },
}

export default actions